import { css, StyleSheet } from 'aphrodite/no-important';
var createStyles = function (color) {
    return StyleSheet.create({
        loaderLabel: {
            color: color || '#A8A8A8',
            fontSize: 10
        }
    });
};
var createMessageClass = function (color) { return css(createStyles(color).loaderLabel); };
export default createMessageClass;
